export default __webpack_public_path__ + "static/media/point-status-5.0bcedfa1.svg";